import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { NavMenuService } from '../../../../core/components/navmenu/navmenu.service';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { TcPerfilUsuarioEnum } from '../../../../core/_infrastructure/types/common';
import { SolicitudExService } from '../../datosbasicos/datosbasicosEx.service';
import { NumerosSeguridadExService } from './numerosseguridad.service';
import { NumeroSeguridadItemResultsViewModel, NumeroSeguridadViewModel } from './numerosseguridad.types';

@Component({
    selector: 'app-numerosseguridad-list',
    templateUrl: './numerosseguridad-list.component.html',
})
export class NumeroSeguridadListComponent extends ComponentBase implements OnInit {
    cols: any[];

    resultNumeroSeguridad: NumeroSeguridadItemResultsViewModel;
    public isCollapsedDatosNumSeguridad = false;
    IdSolicitud: number;

    tieneUsuarioPermisosEdicion: boolean = false;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private navMenuService: NavMenuService,
        protected notificacionService: NotificationService,
        private confirmationService: ConfirmationService,
        protected authService: AuthService,
        protected globalService: GlobalService,
        protected exceptionHandler: ExceptionManager,
        private solicitudExService: SolicitudExService,
        private numerosSeguridadExService: NumerosSeguridadExService,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.resultNumeroSeguridad = new NumeroSeguridadItemResultsViewModel();
    }

    ngOnInit() {
        let id = +this.activatedRoute.snapshot.params['id'];
        this.IdSolicitud = id;

        this.tieneUsuarioPermisosEdicion =
            this.isInspector || this.isCoordinador;

        this.guardRefreshPage(id);

        if (id) {
            this.Search(0);

            this.isCollapsedDatosNumSeguridad = false;
        }

        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'Codigo', header: 'Nº Solicitud' },
            { field: 'CodigoCopia', header: 'Nº Solicitud de Copia' },
            { field: 'TipoSolicitud', header: 'Tipo solicitud' },
            { field: 'NumeroCertificado', header: 'Nº Certificado' },
            { field: 'IdPagina', header: 'Página' },
            { field: 'NumSeguridad', header: 'Nº Seguridad' },
        ];
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudExportacion.Id) || this.navMenuService.currentSolicitudExportacion.Id !== id) {
            this.solicitudExService.getSolicitudEx(id).subscribe(result => {
                this.navMenuService.currentSolicitudExportacion = result;
            });
        }
    }

    Search(pageNumber: number, asc: number = 0, orderBy: string = '') {
        let params = new HttpParams();

        params = params.append('pageNumber', pageNumber.toString());
        params = params.append('asc', asc.toString());
        params = params.append('orderBy', orderBy);
        params = params.append('id', this.IdSolicitud);

        this.loading = true;

        this.numerosSeguridadExService.getNumerosSeguridadPagedByFilter(params).subscribe(result => {
            this.resultNumeroSeguridad = result;
        });

        this.loading = false;
    }

    onSearchLazy(event: any) {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        let pageNumber = event.first / event.rows;

        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onEditNumeroSeguridad(item: NumeroSeguridadViewModel) {
        let numeroSeguridad: number = item.Id;
        this.router.navigate(['/exportacion/solicitud/envioEx/', this.IdSolicitud, 'createNumSeguridad', numeroSeguridad]);
    }

    onDeleteNumeroSeguridad(item: NumeroSeguridadViewModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                this.numerosSeguridadExService.deleteNumeroSeguridad(item.Id).subscribe(() => {
                    this.Search(0);

                    this.addSuccessMessage('Número Seguridad eliminado correctamente');
                });
            },
        });
    }
}
